import type { NDateLocale } from './enUS'
import { id } from 'date-fns/locale'

const dateIdID: NDateLocale = {
  name: 'id-ID',
  locale: id
}

export default dateIdID
